import { NavLink } from 'react-router-dom'
import { useT } from '../hooks'

const SCREENS = [
  { key: 'b_book_pnl', to: '/b-book/pnl' },
  { key: 'b_book_moves', to: '/b-book/moves' },
  { key: 'b_book_report', to: '/b-book/a-vs-b' },
  { key: 'b_book_settings', to: '/b-book' },
]

// The four B-book screens, one tab each, figures first and the settings last, so the desk moves between them without the sidebar.
const BBookNav = () => {
  const { t } = useT()
  return (
    <nav className='b_book_nav' aria-label='B-book'>
      {SCREENS.map(({ key, to }) => (
        <NavLink key={key} to={to} end className={({ isActive }) => `b_book_nav_tab ${isActive ? 'b_book_nav_tab_active' : ''}`}>
          {t(`pages_name.${key}`)}
        </NavLink>
      ))}
    </nav>
  )
}

export default BBookNav
